import React from "react";
import { Box, Typography } from "@mui/material";
import StrategyPerformanceCard from "./StrategyPerformanceCard";

const StrategyCardGrid = ({
  rows = [],
  collapsed = false,
  onFundClick,
  onStrategyClick,
}) => {
  if (!rows?.length) {
    return (
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          border: "1px dashed",
          borderColor: "divider",
          borderRadius: 2,
          backgroundColor: (t) =>
            t.palette.mode === "dark" ? "#1a1818" : t.palette.background.paper,
          color: "text.primary",
        }}
      >
        <Typography variant="body1" color="text.secondary">
          No strategies match the current filters
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: {
          xs: "minmax(0, 1fr)",
          sm: "repeat(2, minmax(0, 1fr))",
          md: "repeat(3, minmax(0, 1fr))",
          lg: "repeat(4, minmax(0, 1fr))",
        },
        columnGap: 2,
        rowGap: 1.5,
        alignItems: "stretch",
      }}
    >
      {rows.map((row, index) => (
        <Box
          key={`${row.fundName}-${row.strategyName}-${index}`}
          sx={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <StrategyPerformanceCard
            row={row}
            collapsed={collapsed}
            onFundClick={onFundClick}
            onStrategyClick={onStrategyClick}
          />
        </Box>
      ))}
    </Box>
  );
};

export default StrategyCardGrid;
